import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=39354f12&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=39354f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39354f12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39354f12')) {
      api.createRecord('39354f12', component.options)
    } else {
      api.reload('39354f12', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=39354f12&scoped=true&", function () {
      api.rerender('39354f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/widgets/BarChart.vue"
export default component.exports